import { DateTime } from "luxon"

// This is the first blocked start date
export const END_OF_YEAR_START_DATE_RESTRICTION_START = DateTime.fromISO("2024-12-20")
// This is the last blocked start date
export const END_OF_YEAR_START_DATE_RESTRICTION_END = DateTime.fromISO("2025-01-12")

// This is the date from where the restrictions start
export const DATE_OF_RESTRICTION_START = DateTime.fromISO("2024-12-01")

export const getUseDifferentStartDateForEndOfYear = () => {
  return (
    // We change dates starting in December 1st and ending in January 5th
    DateTime.now() >= DATE_OF_RESTRICTION_START &&
    DateTime.now() <= END_OF_YEAR_START_DATE_RESTRICTION_END
  )
}
